import { Component, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { GetPadlockToken } from "../../padlock/state/padlock-token.actions";
import {
  selectCredentialLoginError,
  selectCredentialLoginPending,
} from "../../padlock/state/padlock-token.selectors";

@Component({
  selector: "app-auth-dialog",
  templateUrl: "./auth-dialog.component.html",
  styleUrls: ["./auth-dialog.component.scss"],
  standalone: false,
})
export class AuthDialogComponent implements OnInit {
  email: string;
  password: string;
  readonly pending = this.store.selectSignal(selectCredentialLoginPending);
  readonly credentialError = this.store.selectSignal(
    selectCredentialLoginError,
  );

  constructor(private store: Store<any>) {}

  ngOnInit() {}

  login() {
    if (this.pending()) {
      return;
    }
    this.store.dispatch(new GetPadlockToken(this.email, this.password));
  }
}
